
const myInitObject = {    
    "appname": "Quiz Application",
    "google_clientId":"493533555637-a7lpcc46quandc3ala4dnkmmm0ck5egs.apps.googleusercontent.com", 
    "facebook_id":"835698230758546",
   
}
export default myInitObject